import NotFooterLayout from "layouts/NotFooterLayout";
import Warehouse from "components/Warehouse";

function WarehousePage() {
  return (
    <NotFooterLayout namePage="คลังสินค้า">
      <div className="layout-content">
        <Warehouse />
      </div>
    </NotFooterLayout>
  );
}

export default WarehousePage;
